<template>
  <!-- THIS IS ONLY FOR TESTING, IT SHOULD BE DELETED WHEN THINGS GET REAL -->
  <div
    id="main-content"
    class="container"
  >
    <div class="row">
      <button
        type="button"
        @click="generateNotAlarmNotificationForUser"
      >
        Generate normal notification
      </button>
      <button
        type="button"
        @click="generateAlarmNotificationForUser"
      >
        Generate alarm notification
      </button>
      <button
        type="button"
        @click="activateGlobalNotifications"
      >
        Activate global notifications
      </button>
      <button
        type="button"
        @click="disableGlobalNotifications"
      >
        Disable global notifications
      </button>
    </div>
    <div
      class="row"
      style="border-top: black 1px solid;margin-top: 10px"
    >
      <div class="col-md-6">
        <div class="form-group">
          <label for="connect">WebSocket connection:</label>
          <button
            id="connect"
            class="btn btn-default"
            type="button"
            :disabled="connected"
            @click="connect"
          >
            Connect
          </button>
          <button
            id="disconnect"
            class="btn btn-default"
            type="submit"
            :disabled="!connected"
            @click="disconnect"
          >
            Disconnect
          </button>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="message">What is your message?</label>
          <input
            id="message"
            v-model="message"
            type="text"
            class="form-control"
            placeholder="Your message here..."
            aria-hidden="true"
            @keyup.enter="sendName"
          >
        </div>
        <button
          id="send"
          class="btn btn-default"
          type="button"
          :disabled="!connected"
          @click="sendName"
        >
          Send
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table
          v-if="connected"
          id="conversation"
          class="table table-striped"
        >
          <caption>Messages</caption>
          <thead>
            <tr>
              <th scope="col">
                Messages
              </th>
            </tr>
          </thead>
          <tbody id="messages">
            <tr
              v-for="messageItem in messages"
              :key="messageItem"
            >
              <td>{{ messageItem }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { auth } from '@/api/auth'
import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'
import axios from 'axios'
import { WEBSOCKET_BASE_URL } from '@/api/api'

export default {
    message: 'WebsocketTest',
    data() {
        return {
            stompClient: null,
            message: '',
            connected: false,
            messages: []
        }
    },
    methods: {
        connect() {
            // Please do not use the code of this class to make your own implementation.
            // Better check what is being done in NavBar for inbox notifications :)
            const socket = new SockJS(WEBSOCKET_BASE_URL + '/main/?authenticationToken=' + auth.token)
            this.stompClient = Stomp.over(socket)
            this.stompClient.connect(
                {},
                frame => {
                    this.connected = true
                    this.stompClient.subscribe('/topic/simpleGlobalChat',
                        message => {
                            this.showMessage(JSON.parse(message.body).content)
                        })
                }, error => {
                    console.error(error)
                    this.disconnect()
                }
            )
        },
        disconnect() {
            if (this.stompClient !== null) {
                this.stompClient.disconnect()
            }
            this.connected = false
            this.messages = []
        },
        sendName() {
            const message = JSON.stringify({ 'content': this.message })
            this.stompClient.send('/app/simpleGlobalChat', message, {})
            this.message = ''
        },
        showMessage(message) {
            this.messages.push(message)
        },
        async generateAlarmNotificationForUser() {
            const laboratoryId = this.$store.getters.labId
            const username = this.$store.getters.userInformation?.username
            const response = await axios.post(`/admin/notificationTests/generateAlarmNotificationForUser?laboratoryId=${laboratoryId}&username=${username}`)
            return response.data
        },
        async generateNotAlarmNotificationForUser() {
            const laboratoryId = this.$store.getters.labId
            const username = this.$store.getters.userInformation?.username
            const response = await axios.post(`/admin/notificationTests/generateNotAlarmNotificationForUser?laboratoryId=${laboratoryId}&username=${username}`)
            return response.data
        },
        async activateGlobalNotifications() {
            const active = true
            return this.updateGlobalNotifications(active)
        },
        async disableGlobalNotifications() {
            const active = false
            return this.updateGlobalNotifications(active)
        },
        async updateGlobalNotifications(active) {
            const response = await axios.put(`/admin/notificationTests/updateGlobalNotifications?active=${active}`)
            return response.data
        }
    }
}
</script>

<style scoped lang="scss">
    #main-content {
        max-width: 940px;
        padding: 2em 3em;
        margin: 0 auto 20px;
        background-color: #fff;
        border: 1px solid #e5e5e5;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }
</style>
